module.exports = __webpack_public_path__ + "static/media/recommended.1e98237e.svg";